export default {
  PageName: '跨境业务',
  SearchPlaceholder: '搜索 跨境线路/客户名称',
  viewBw: '查看跨境流量',
  sn: '专线SN',
  lineName: '线路名称',
  crossBorderLineBw: '跨境线路带宽(M)',
  customerBw: '客户订购带宽(M)',
  allBw: '总订购带宽(M)',
  CrossFlow: '跨境流量',
  OrderCustomer: '订购客户',
  AllCustomers: '全部客户',
  StatisticsTime: '统计时间',
  upTraffic: '上行流量',
  downTraffic: '下行流量',
}